import { render, staticRenderFns } from "./ZebraBlindChoice.vue?vue&type=template&id=2a54d4e3&scoped=true&"
import script from "./ZebraBlindChoice.vue?vue&type=script&lang=js&"
export * from "./ZebraBlindChoice.vue?vue&type=script&lang=js&"
import style0 from "./ZebraBlindChoice.vue?vue&type=style&index=0&id=2a54d4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a54d4e3",
  null
  
)

export default component.exports